import { useEffect, useState } from 'react';

/**
 * True only once `flag` has been continuously true for `delayMs`; false the
 * moment `flag` clears. Gate loading placeholders on it so a response that
 * arrives quickly never flashes a skeleton for a few frames.
 */
export const useDelayedFlag = (flag: boolean, delayMs: number): boolean => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!flag) {
      setElapsed(false);
      return undefined;
    }
    const handle = setTimeout(() => setElapsed(true), delayMs);
    return () => clearTimeout(handle);
  }, [flag, delayMs]);

  return flag && elapsed;
};
